import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { meApi } from '../user/meApi';
import { transactionApi } from '../transaction/transactionApi';
import { profileApi } from '../profile/profileApi';

export interface TransferPointsRequest {
  recipientId: number;
  amount: number;
  message: string;
  tradeId?: string;
}

export interface TransferPointsResponse {
  success: boolean;
  message?: string;
  senderNewBalance: number;
  amount: number;
}

export const pointsApi = createApi({
  reducerPath: 'pointsApi',
  baseQuery: baseQuery,
  tagTypes: ['PointTransfers'],
  endpoints: (builder) => ({
    transferPoints: builder.mutation<TransferPointsResponse, TransferPointsRequest>({
      query: (body) => ({
        url: '/points/transfer',
        method: 'POST',
        body,
        requiresAuth: true,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(meApi.util.invalidateTags(['User']));
          dispatch(transactionApi.util.invalidateTags(['Transactions']));
          dispatch(profileApi.util.invalidateTags(['PublicProfile']));
        } catch {
          // Mutation itself handles error states
        }
      },
    }),
  }),
});

export const { useTransferPointsMutation } = pointsApi;
